<template>
  <div class="x-search-option">
    <div v-if="searchOptionType === 'multipleChoice'" class="x-multiple-choice">
      <el-button type="primary" @click="clickIcon(false)">请选择</el-button>
      <div class="x-multiple-choice-tag-container">
        <el-tag
          size="medium"
          :key="tag[realRenderKey]"
          v-for="(tag, index) in dynamicTags"
          color="#eee"
          closable
          :disabled="disabled"
          :disable-transitions="false"
          @close="handleClose({ tag, index })"
          >{{ getTagText(tag) }}</el-tag
        >
      </div>
    </div>
    <div
      v-else-if="searchOptionType === 'multipleSelect'"
      class="x-multiple-select"
      :class="{ 'disabled-x-multiple-select': disabled }"
      @click="handleClickToFocus"
    >
      <el-tag
        size="small"
        :key="tag[realRenderKey]"
        v-for="(tag, index) in dynamicTags"
        color="#eee"
        closable
        :disabled="disabled"
        :disable-transitions="false"
        @close="handleClose({ tag, index })"
        >{{ getTagText(tag) }}</el-tag
      >
      <input
        v-if="hasInput"
        type="text"
        class="multiple-select__input"
        ref="multipleSelectInput"
        :disabled="disabled"
        @keydown.enter.stop.prevent="handleMultipleInputByEnter"
        @blur="handleMultipleInputByBlur"
      />
      <i class="el-icon-more more-operation" @click="clickIcon(false)"></i>
    </div>
    <template v-else>
      <el-autocomplete
        v-if="$attrs.debounce > -1"
        :disabled="disabled"
        class="x-single-select-autocomplete"
        ref="autoComplete"
        :value="value"
        v-bind="$attrs"
        v-on="$listeners"
        :fetch-suggestions="handleSuggestions"
      >
        <i class="el-icon-more more-operation" slot="suffix" @click="clickIcon(false)"></i>
        <template v-slot:default="{ item }">
          <slot name="search-option" :item="item">
            <el-row type="flex">
              <el-col :span="12">{{ item[rowKey] }}</el-col>
              <el-col :span="12">{{ item[rowName] }}</el-col>
            </el-row>
          </slot>
        </template>
      </el-autocomplete>
      <el-input
        class="x-single-select-input"
        v-else
        :disabled="disabled"
        :value="value"
        v-bind="$attrs"
        v-on="$listeners"
        ref="input"
        @keydown.enter.native.stop="clickIcon(true, value)"
      >
        <template v-slot:suffix>
          <i class="el-icon-more more-operation" @click="clickIcon(false, value)"></i>
          <i
            v-if="realReadonlyClearable"
            class="el-input__icon el-icon-circle-close el-input__clear x-single-select-input-clear"
            @mousedown.prevent
            @click="clear"
          ></i>
        </template>
      </el-input>
    </template>
  </div>
</template>

<script>
import { SINGLE_SELECT } from '@/mixin/search-dialog-mixin';
import { Input, Tag, Button } from 'element-ui';
import { isNotEmpty } from '@/util/appUtils';
export default {
  name: 'XSearchOption',
  inheritAttrs: false,
  components: {
    [Tag.name]: Tag,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 建议列表，如果传入了该参数，fetchSuggestions都不再生效
    suggestions: {
      type: Array,
      default: () => {
        return null;
      }
    },
    // 自定义获取建议列表的方法
    fetchSuggestions: {
      type: Function,
      default: null
    },
    searchOptionType: {
      type: String,
      default: SINGLE_SELECT
    },
    dynamicTags: {
      type: Array,
      default: () => {
        return [];
      }
    },
    rowKey: {
      type: String,
      default: 'id'
    },
    // 渲染的key
    renderKey: String,
    // 启用输入框进行查询
    hasInput: {
      type: Boolean,
      default: false
    },
    rowName: String,
    readonlyClearable: Boolean,
    triggerSearch: Function
  },
  methods: {
    clear() {
      this.$emit('input', '');
      this.$emit('change', '');
      this.$emit('clear');
    },
    handleClearMultipleInputVal() {
      if (this.$refs.multipleSelectInput) {
        this.$refs.multipleSelectInput.value = '';
      }
    },
    handleMultipleInputFocus() {
      if (this.$refs.multipleSelectInput) {
        this.$refs.multipleSelectInput.focus();
      }
    },
    handleClickToFocus() {
      if (!this.hasInput) return;
      this.handleMultipleInputFocus();
    },
    handleMultipleInputByEnter($event) {
      this.clickIcon(true, $event.target.value);
      // const $searchList = this.$parent;
      // const presetConfig = 'preset-config';
      // const fieldCode = this.rowKey;
      // const fieldValue = $event.target.value;
      // if (Object.prototype.hasOwnProperty.call($searchList.$attrs, 'preset-config')) {
      //   $searchList.$attrs['preset-config'] = [{fieldCode, fieldValue}];
      // } else {
      //   $searchList.$attrs.presetConfig = [{fieldCode, fieldValue}];
      // }
      // $searchList.$forceUpdate();
      //
      // $searchList.showDialog(true).then(res => {
      //   console.log(res);
      //   this.handleClearMultipleInputVal();
      //   this.handleMultipleInputFocus();
      // });
    },
    handleMultipleInputByBlur() {
      this.handleClearMultipleInputVal();
    },
    getTagText(tag) {
      return tag[this.realRowName];
    },
    blur() {
      // autoComplete没有blur方法
      // if (this.$refs.autoComplete) {
      //   this.$refs.autoComplete.blur();
      // }
      if (this.$refs.input) {
        this.$refs.input.blur();
      }
    },
    clickIcon(flag, value) {
      if (this.disabled) {
        return;
      }
      this.blur();
      this.$refs.autoComplete && this.$refs.autoComplete.close();
      this.enterPress = flag;
      if (this.triggerSearch) {
        this.triggerSearch({ flag, value, searchOptionType: this.searchOptionType });
      }
      // this.$emit('click-icon', {flag, value, searchOptionType: this.searchOptionType});
    },
    handleClose(args) {
      if (this.disabled) {
        return;
      }
      this.$emit('remove-tag', args);
    },
    handleSuggestions(queryString, cb) {
      // 如果用户按了回车键，就需要终止查询
      if (this.enterPress) {
        this.enterPress = false;
        return;
      }
      if (Array.isArray(this.suggestions)) {
        if (!queryString) {
          cb(this.suggestions);
          return;
        }
        const suggestions = [];
        for (const item of this.suggestions) {
          if (
            item[this.rowKey].toString().indexOf(queryString) > -1 ||
            item[this.rowName].toLowerCase().indexOf(queryString.toLowerCase()) > -1
          ) {
            suggestions.push(item);
          }
        }
        cb(suggestions);
        return;
      }
      if (this.fetchSuggestions) {
        this.fetchSuggestions(queryString, result => {
          cb(result);
        });
        return;
      }
      // eslint-disable-next-line
      cb([]);
    }
  },
  computed: {
    realRenderKey() {
      if (isNotEmpty(this.renderKey)) {
        return this.renderKey;
      }
      return this.rowKey;
    },
    /**
     * 真正的rowName,用户没有传入rowName的情况下使用rowKey来表示
     * @return {*}
     */
    realRowName() {
      return this.rowName || this.rowKey;
    },
    realReadonlyClearable() {
      if (this.disabled === true) {
        return false;
      }
      return this.$attrs.readonly === true && this.readonlyClearable === true;
    }
  }
};
</script>
<style lang="scss">
@import "../../style/mixins/index";

.x-search-option {
  .el-autocomplete{
    width: 100%;
  }
  .more-operation {
    position: absolute;
  }
  .x-multiple-choice {
    .x-multiple-choice-tag-container {
      margin-top: 10px;
      .el-tag {
        background-color: #fff !important;
        display: flex;
        justify-content: space-between;
        height: 32px;
        align-items: center;
        padding: 0 10px;
        border-color: unset;
        border-width: unset;
        border-style: unset;
        color: #505566;
        ::v-deep .el-tag__close{
          background-color: #aaa;
          color: #fff;
        }
      }
      .el-tag:hover{
        background-color: #F5F7FA !important;
      }
    }
  }
  .disabled-x-multiple-select {
    background-color: #f5f7fa!important;
    color: #64666d!important;
    border-color: #BBC5D9!important;
  }
  .x-multiple-select {
    /*如果修改element的全局size,这个高度就要改变*/
    font-size: 0;
    /*如果line-height使用继承的28px，在有内容的情况下，外加1px的border就会使盒子的高度变成30px*/
    line-height: 26px;
    min-height: 26px;
    border: 1px solid #BBC5D9;
    border-radius: 4px;
    position: relative;
    padding-left: 2px;
    padding-right: 25px;
    display: flex;
    flex-wrap: wrap;
    .more-operation {
      top: 5px;
      right: 5px;
      &:hover {
        cursor: pointer;
      }
    }
    .el-tag {
      color: #babdca;
      border: 1px solid #e4e7ed;
      margin-top: 1px;
      margin-right: 10px;
      vertical-align: top;
      .el-tag__close {
        margin-left: 4px;
        background-color: #aaa;
        color: #fff;
      }
    }
    .multiple-select__input{
      display: block;
      position: relative;
      z-index: 999;
      width: 63px;
      height: 24px;
      border: none;
      font-size: 12px;
      outline: medium;
      background-color: transparent;
    }
  }
  .x-single-select-input.el-input--mini .more-operation, .x-single-select-autocomplete .el-input--mini .more-operation {
    top: 6px;
    right: 1px;
  }
  .x-single-select-input.el-input--mini>.el-input__suffix>.el-input__suffix-inner>.el-input__clear {
    margin-right: 20px;
  }
}
</style>